import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/content";

export const Admin = () => {
  const { t } = useLang();
  const points = ["admin_point_1", "admin_point_2", "admin_point_3"];
  return (
    <section className="relative py-24 lg:py-32 bg-[#08080A] border-y border-white/10" data-testid="admin-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="min-w-0"
        >
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("admin_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("admin_title")}</h2>
          <p className="mt-5 text-base text-zinc-400 leading-relaxed">{t("admin_subtitle")}</p>
          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3" data-testid={`admin-${p}`}>
                <span className="mt-0.5 w-6 h-6 rounded-md bg-[#00F0FF]/15 border border-[#00F0FF]/40 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-cyan" />
                </span>
                <span className="text-zinc-300">{t(p)}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-2xl overflow-hidden border border-[#00F0FF]/20"
        >
          <img src={IMAGES.supersonic} alt="MACAS project administration blueprint" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#030305] via-transparent to-transparent" />
          <div className="absolute bottom-4 left-4 font-mono text-xs text-cyan bg-black/60 px-3 py-1.5 rounded-md border border-[#00F0FF]/20">
            MACAS_OS · v24.0
          </div>
        </motion.div>
      </div>
    </section>
  );
};
